// node modules
import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
// modules
import { useStore } from 'modules/Stores';
import AnalyticService from 'modules/Analytics';
// consts
import { EVENTS } from 'modules/Analytics/consts';

type Props = {
  children: JSX.Element;
};

const TradingInitProvider: React.FC<Props> = ({ children }) => {
  const { init } = useStore('AppStore');
  const { ucc, profileId, profile } = useStore('UserStore');

  useEffect(() => {
    init();
  }, [init]);

 const sendUserAgentDetailsToMixpanel = () => {
    AnalyticService.sendEvent(EVENTS.USER_AGENT, {}, true);
  };

  useEffect(() => {
    // analytics
    AnalyticService.setUser(profileId);
    AnalyticService.setUserData({
      ucc,
      profileId,
      mobile: profile?.mobile,
    });
    sendUserAgentDetailsToMixpanel();
  }, [ucc, profileId, profile]);

  return children;
};

export default observer(TradingInitProvider);
